{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "ContactInfo",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "items"
  ],
  "properties": {
    "items": {
      "title": "Boxes",
      "type": "array",
      "maxItems": 4,
      "x-ui": "list",
      "x-itemTitle": "text",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "icon",
          "text"
        ],
        "properties": {
          "icon": {
            "title": "Icon",
            "enum": [
              "location",
              "phone",
              "email"
            ],
            "x-ui": "select"
          },
          "text": {
            "title": "Text",
            "type": "string",
            "maxLength": 150
          },
          "href": {
            "title": "Link",
            "type": "string",
            "maxLength": 500,
            "pattern": "^(|page:[0-9a-fA-F-]{36}|/[^\\s]*|https?://[^\\s]+|mailto:[^\\s]+|tel:[+0-9 ]+|#[A-Za-z0-9_-]*)$",
            "x-ui": "link"
          },
          "subText": {
            "title": "Second line",
            "type": "string",
            "maxLength": 150
          },
          "tracking": {
            "title": "Tracking event",
            "enum": [
              "",
              "phone",
              "email",
              "maps",
              "whatsapp"
            ],
            "x-ui": "select"
          }
        }
      }
    }
  }
}
